import { YonetimAnaSayfaPage } from './../Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { DalProvider } from './../../providers/dal/dal';
import { NavController, App, Platform, MenuController, NavParams } from 'ionic-angular';
import { DashAnaSayfaPage } from './../dash-ana-sayfa/dash-ana-sayfa';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Ortak } from './../../providers/ortak';
import { GirisPage } from './../giris/giris';
import { Component } from '@angular/core';
import { PagesProvider } from '../../providers/pages-provider';
declare var toastr: any;

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  kullaniciyetkiseviyesi: any;
  aktifKullanici: any;
  users: any = {};
  usertemp: any = { ID: "", Sifre: "", Name: "", OffMode: "" };
  menuler = [];
  gunSonu = false;
  name = "";
  sifre = "";
  MusteriCekleri = [];
  MusteriSenetleri = [];
  Cekler = [];
  subeadi="";
  Senetler = [];
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public app: App,
    public platform: Platform,
    public menu: MenuController,
    public dalls: DalProvider,
    public toast: ToastController,
    public androidFullScrenn: AndroidFullScreen,
    public navParams: NavParams,
  ) {
    if (navParams.get("user") != null) {
      this.users = navParams.get("user");
      this.name = this.users.Name;
      this.sifre = this.users.Sifre;

    }

    menu.enable(true);
//this.subeadi=this.ortak.storageServisBilgisiGetir.Tanim;
    this.kullaniciyetkiseviyesi = this.users.Type;
   // this.kullaniciyetki();
    this.aktifKullanici = this.users.Name;

    this.MenuleriGoruntule();
  }
  ionViewDidLoad() {
//     this.kullanicikontrol();
//     this.YaklasanMusteriCekKontrol();
//     this.YaklasanMusteriSenetKontrol();
//     this.OdemesiYaklasanCekKontrol();
//     this.OdemesiYaklasanSenetKontrol();
//  this.DovizGuncelle();
  }
  DovizGuncelle() {
    var formData = new FormData();
   
        this.bllOrtak.islem(formData, "DolarKurGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        
        console.log("hata",sonuc)

      })
    }    

  YaklasanMusteriCekKontrol() {
    return new Promise((res, err) => {
      this.bllOrtak.islemWithoutPost("YaklasanMusteriCekler", "", false).then(a => {
        var sonuc = <any>a;
        this.MusteriCekleri = sonuc.SonucObject;
        if (this.MusteriCekleri.length > 0) {
          var toastOptions = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": function () { YonetimAnaSayfaPage },
            "showDuration": "1000",
            "hideDuration": "500",
            "timeOut": "13000",
            "extendedTimeOut": "13000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          }
          toastr.options = toastOptions;
          toastr.error("Vadesi Yaklaşan Müşteri Çekleri Var!", 'Müşteri Çekleri');
        }
      })
    })
  }
  YaklasanMusteriSenetKontrol() {
    return new Promise((res, err) => {
      this.bllOrtak.islemWithoutPost("YaklasanMusteriSenetler", "", false).then(a => {
        var sonuc = <any>a;
        this.MusteriSenetleri = sonuc.SonucObject;
        if (this.MusteriSenetleri.length > 0) {
          var toastOptions = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": function () { YonetimAnaSayfaPage },
            "showDuration": "1000",
            "hideDuration": "500",
            "timeOut": "13000",
            "extendedTimeOut": "13000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          }
          toastr.options = toastOptions;
          toastr.error("Vadesi Yaklaşan Müşteri Senetleri Var!", 'Müşteri Senetleri');
        }
      })
    })
  }
  OdemesiYaklasanCekKontrol() {
    return new Promise((res, err) => {
      this.bllOrtak.islemWithoutPost("OdemesiYaklasanCekler", "", false).then(a => {
        var sonuc = <any>a;
        this.MusteriSenetleri = sonuc.SonucObject;
        if (this.MusteriSenetleri.length > 0) {
          var toastOptions = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": function () { YonetimAnaSayfaPage },
            "showDuration": "1000",
            "hideDuration": "500",
            "timeOut": "13000",
            "extendedTimeOut": "13000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          }
          toastr.options = toastOptions;
          toastr.error("Ödemesi Yaklaşan Çekler  Var!", 'Çekler ');
        }
      })
    })
  }
  OdemesiYaklasanSenetKontrol() {
    return new Promise((res, err) => {
      this.bllOrtak.islemWithoutPost("OdemesiYaklasanSenetler", "", false).then(a => {
        var sonuc = <any>a;
        this.MusteriSenetleri = sonuc.SonucObject;
        if (this.MusteriSenetleri.length > 0) {
          var toastOptions = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": function () { YonetimAnaSayfaPage },
            "showDuration": "1000",
            "hideDuration": "500",
            "timeOut": "13000",
            "extendedTimeOut": "13000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          }
          toastr.options = toastOptions;
          toastr.error("Ödemesi Yaklaşan Senetler  Var!", 'Senetler ');
        }
      })
    })
  }
  kullaniciyetki() {
    if (this.kullaniciyetkiseviyesi == null || this.kullaniciyetkiseviyesi == "") {
      this.kullaniciyetkiseviyesi = this.ortak.kullaniciType;
    }
  }
  kullanicikontrol() {

    this.androidFullScrenn.isImmersiveModeSupported()
      .then(() => this.Kontroledilecek())
      .catch((error: any) => console.log());

  }

  Kontroledilecek() {

    var fromdata = new FormData();
    fromdata.append("name", this.name);
    fromdata.append("sifre", this.sifre);
    this.bllOrtak.islem(fromdata, "UserKontrol", "", false).then(a => {
      var sonuc = <any>a;
      this.usertemp = sonuc.SonucObject;

      if (this.usertemp.ID == null) {
        this.ortak.showBasicAlert("Hata", "Kullanıcı Kısıtlanmıştır");
        this.navCtrl.setRoot(GirisPage);
      }
      if (this.usertemp.OffMode == 0) {
        Ortak.sqlType = "web";
        var sqlDriver;
        if (Ortak.sqlType == "web") {
          sqlDriver = {
            database: "VT.db",
            type: "websql",
            storage: "sqlite",
          };
        }
        else {
          sqlDriver = {
            database: "VT.db",
            type: "websql",
            storage: "sqlite",
          };
        }
        return new Promise((res, err) => {
          this.dalls.SifirlanacakTablolariSil().then(a => {
            this.dalls.createAndGetConnection(sqlDriver).then(k => {
             // res();

            });
          }).catch(z => {
            err();
            console.log(z);
          })
        })

      }
    });
  }

  Cikis() {
    this.navCtrl.setRoot(GirisPage);
  }

  dashboard() {
    this.navCtrl.push(DashAnaSayfaPage);
  }


  MenuleriGoruntule() {
    var pagesProvider = new PagesProvider();
    pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      if (this.kullaniciyetkiseviyesi == 2) {// Yönetici ise tüm menüleri yükle
        this.menuler = sonuc.MAIN_MENU;
      }
      if (this.kullaniciyetkiseviyesi == 3) {// Yönetici ise tüm menüleri yükle
        this.menuler = sonuc.MAIN_MENU;
      }
      else if (this.kullaniciyetkiseviyesi == 1) {// Kasiyer ise
        this.menuler = sonuc.KULLANICI_MENU;
      }

    })
  }
  menuItemClick(item) {
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.PAGE_COMPONENT];
    else
      component = item.PAGE_COMPONENT;
    if (component == GirisPage) {
      //  this.ortak.storeagePersonelCikar();
    }
    this.navCtrl.push(component);
  }



  kapat() {
    this.ortak.showConfirmAlert("Uyarı", "Uygulama Kapanacak. Devam etmek istiyor musunuz?").then(k => {

      this.platform.exitApp();
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts